import React from 'react';
import styled from 'styled-components';
import {
  Container,
  Row,
  Col,
} from 'reactstrap';
import { Link } from 'react-router-dom';

import breakpoints from '../util/breakpoints';
import DefaultLayout from '../layouts/DefaultLayout';
import FadeInImg from '../components/FadeInImg';
import LetsBuildTogether from '../components/ui/LetsBuildTogether';

import data from '../data/index';

const ThisContainer = styled(Container)`
  margin-top: 60px;
`;

const ImageCol = styled(Col)`
  padding: 0;
  background: #111323;
`;

const SmallImageCol = styled(ImageCol)`
  min-height: 300px;
`;

const LargeImageCol = styled(ImageCol)`
  min-height: 525px;
`;

const VideoCol = styled(Col)`
  padding: 0;
`;

const Video = styled.video`
  display: block;
  position: relative;
  box-shadow: 0 2px 57px rgba(0,0,0,0.15);
  z-index: 1;
`;

const LargeVideoCol = ({ src }) => (
  <VideoCol>
    <Video autoPlay={true} loop={true} width="100%" src={src} />
  </VideoCol>
);

const HeaderRow = styled(Row)`
  position: relative;
  background-color: white;

  h1 {
    font-weight: 700;
    font-size: 4em;
    padding: 50px 0 10px 10px;
    text-transform: lowercase;
    line-height: 0.8em;

    ${breakpoints.sm`
      font-size: 5em;
    `}
  }
`;

const DescriptionRow = styled(Row)`
  position: relative;
  background-color: white;
  padding: 30px 20px 70px;
`;

const DescriptionCol = styled(Col)`

  h2 {
    font-weight: 700;
    font-size: 2.2em;
    padding: 50px 0 15px;
    text-transform: lowercase;
  }

  p {
    color: #777;
  }
`;

const TagList = styled.ul`
  float: left;
  margin: 0;
  padding: 0 0 30px 0;
  margin-top: 5px;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  li {
    float: left;
    list-style: none;
    font-size: 0.75em;
    font-weight: 700;
    padding: 0px 18px 5px 0px;
  }
`;

const SubTitle = styled.p`
  font-weight: 700;
  padding-top: 0;
`;

const List = styled.ul`
  color: #777;
`;

const LinkRow = styled(Row)`
  padding-top: 30px;

  & > div {
    padding: 0 0 30px 0;

    ${breakpoints.md`
      padding: 0;
    `}
  }

  a {
    display: block;
    background-color: white;
    margin: 0;
    font-size: 1.6em;
    font-weight: bold;
    color: black;
    padding: 50px 50px 80px;
    text-align: left;
  }

  a:hover {
    text-decoration: none;

    span::before {
      width: 100%;
    }
  }

  a span {
    position: relative;
    float: left;
    display: block;
    text-transform: uppercase;
    font-size: 0.5em;
    font-weight: 700;
    letter-spacing: 0.2em;
    border-bottom: 2px solid black;
    margin-top: 20px;
    z-index: 1;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      background-color: #89e7c6;
      width: 0;
      height: 100%;
      display: block;
      z-index: -1;

      transition: width 0.5s ease-out;
    }
  }

  & > div:first-child {
    text-align: left;

    ${breakpoints.md`
      a { margin-right: 15px; }
    `}
  }

  & > div:last-child {
    text-align: right;

    ${breakpoints.md`
      a { margin-left: 15px; }
    `}
  }


`;

const WorkDetailPage = ({ match }) => {

  let project = data[match.params.project];

  return (
    <DefaultLayout>
      <ThisContainer>

        <Row>
          <SmallImageCol>
            <FadeInImg src={project.heroImage} />
          </SmallImageCol>
        </Row>

        <HeaderRow>
          <Col sm={{ size: 10, offset: 1 }}>
            <h1>{project.title}</h1>
          </Col>
        </HeaderRow>

        <DescriptionRow>
          <DescriptionCol sm={{ size: 10, offset: 1 }} lg={{ size: 3, offset: 1 }} xl={{ size: 4, offset: 1 }}>
            <TagList>
              {project.tagList.map((tag, i) =>
                <li key={i}>{tag}</li>
              )}
            </TagList>
          </DescriptionCol>
          <DescriptionCol sm={{ size: 10, offset: 1 }} lg={{ size: 6, offset: 1 }} xl={{ size: 6, offset: 0 }}>
            <SubTitle>{project.subTitle}</SubTitle>
            <p>{project.description}</p>
          </DescriptionCol>
        </DescriptionRow>

        {project.rows.map((row, i) =>
          <div key={i}>
            <Row>
              {row.image &&
                <LargeImageCol>
                  <FadeInImg src={row.image} />
                </LargeImageCol>
              }
              {row.video &&
                <LargeVideoCol src={row.video} />
              }
            </Row>

            <DescriptionRow>
              <DescriptionCol sm={{ size: 10, offset: 1 }} md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }}>
                {row.sections.map((section, i) =>
                  <div key={i}>
                    <h2>{section.title}</h2>

                    {(typeof section.content === "string") &&
                      <p>{section.content}</p>
                    }

                    {(typeof section.content === "object") &&
                      <List>
                        {section.content.map((item, i) =>
                          <li key={i}>{item}</li>
                        )}
                      </List>
                    }
                  </div>
                )}
              </DescriptionCol>
            </DescriptionRow>
          </div>
        )}

        <LinkRow>
          <Col sm="12" md="6">
            <a href={project.liveLink.src} target="_blank">{project.liveLink.text}<br /><span>{project.liveLink.ctaText}</span></a>
          </Col>
          <Col sm="12" md="6">
            <Link to={project.internalLink.src}>{project.internalLink.text}<br /><span>{project.internalLink.ctaText}</span></Link>
          </Col>
        </LinkRow>

      </ThisContainer>

      <LetsBuildTogether />

    </DefaultLayout>
  );
};

export default WorkDetailPage;



// WEBPACK FOOTER //
// ./src/pages/WorkDetailPage.js